export class TableHeader<T> {
    public key: T;
    public title: string;
    public isSortable: boolean;

    constructor(
        key: T,
        title: string,
        isSortable: boolean,
    ) {
        this.key = key;
        this.title = title;
        this.isSortable = isSortable;
    }
}